import { Button, Icon, tailwindOverride } from '@getsynapse/design-system';
import intl from 'react-intl-universal';

interface DeleteUserButtonProps {
  toggleModal: () => void;
  disabled?: boolean;
}

const DeleteUserButton = ({ toggleModal, disabled }: DeleteUserButtonProps) => {
  return (
    <Button
      onClick={toggleModal}
      variant='tertiary'
      className='flex items-center gap-x-2 py-1.5'
      disabled={disabled}
    >
      <Icon
        name='trash'
        className={tailwindOverride('text-error-dark text-lg', {
          'text-primary-lighter cursor-not-allowed': disabled,
        })}
      />
      {intl.get('SETTINGS_PAGE.USER_PAGE.DELETE_USER.TITLE')}
    </Button>
  );
};

export default DeleteUserButton;
